"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "“Jerry was friendly, prompt, communicative, efficient, fairly priced, and did a great job on our bathroom remodel. He accommodated our timeline and finished in the timeframe promised. We would highly recommend Jerry!”",
  name: "MAUREEN F.",
  badge: "Bathroom Remodel in Hudson, WI"
}, {
  quote: "“Jerry did a great job from start to finish. He listened to our ideas and responded with agreement or with suggestion (which we wanted). He started when he said he would and finished in a timely manner. We could not be any happier with the results - we feel like we're in a spa now.”",
  name: "DENIS L.",
  badge: "Master Bath Hudson, WI"
}, {
  quote: "“Finely Done remodeled both my kitchen and master bath. They were wonderful to work with. They took my vision and brought it to life exactly as I requested it! They had good suggestions if I was uncertain of decisions. They were always friendly and ready to take my calls if I had questions. My rooms are now beautiful! I could not be happier.”",
  name: "KELLI B.",
  badge: "Kitchen/Bath Remodel Hudson, WI"
}, {
  quote: "“Jerry transformed my master bathroom and guest bathroom and kitchen. He Installed two gorgeous showers and new cabinetry, sinks at the proper height. It's a twenty five year old townhouse that really needed updating. I couldn't be happier with the results and quality of the work. I would highly recommend Finely Done to anyone for a remodeling project.”",
  name: "MAURICE S.",
  badge: "Bathroom Remodel Ellsworth, WI"
}, {
  quote: "“I had a basement remodel to include a bathroom, bedroom and walk in closet. The craftsmanship of the work is exceptional. Jerry and his team are a delight to work with. I highly recommend Jerry for any project.”",
  name: "VICTORIA D.",
  badge: "Basement Remodel Prescott, WI"
}];
export default function HomeownerSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="16429" id="client-success-stories" ref={ref} className={cn("bg-background py-24 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 max-w-2xl">
          <h2 className="text-primary font-serif text-4xl font-medium tracking-tight md:text-6xl">
            Client Success Stories
          </h2>
          <p className="text-muted-foreground mt-6 text-xl leading-relaxed">
            Real experiences from neighbors who value heritage craftsmanship, 
            trust, and long-term quality in their home renovations.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <div className="h-full p-1">
                  <Card className="bg-card relative flex h-full flex-col justify-between overflow-hidden border-none shadow-xl transition-all duration-300 hover:shadow-2xl rounded-sm">
                    <CardContent className="relative flex flex-1 flex-col gap-6 p-10">
                      {}
                      <Quote className="text-chart-2 absolute top-8 left-8 -z-10 size-24 opacity-10" />

                      <div className="relative z-10 flex-1">
                        <p className="text-foreground/90 font-serif text-xl leading-relaxed italic">
                          &ldquo;{item.quote}&rdquo;
                        </p>
                      </div>

                      <div className="relative z-10 mt-auto flex flex-col gap-4 border-t border-border/40 pt-8">
                        <h4 className="text-primary font-sans font-semibold tracking-wide uppercase text-sm">
                          {item.name}
                        </h4>
                        <Badge variant="secondary" className="bg-secondary/30 text-primary w-fit rounded-sm px-4 py-1.5 text-xs font-medium tracking-wider">
                          {item.badge}
                        </Badge>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="mt-12 flex justify-center gap-4 pr-2">
            <CarouselPrevious variant="outline" className="border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground static size-14 translate-x-0 translate-y-0 rounded-sm transition-all duration-300" />
            <CarouselNext variant="outline" className="border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground static size-14 translate-x-0 translate-y-0 rounded-sm transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}